<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div
    v-if="!loading"
    v-bind:style="{'--venus-color-primary': style.primary, '--venus-color-secondary': style.secondary, '--p': style.primary, '--s': style.secondary}"
  >
    <div class="drawer drawer-mobile">
      <input id="my-drawer-2" type="checkbox" class="drawer-toggle" />
      <div class="drawer-content flex flex-col">
        <!-- Page content here -->
        <label for="my-drawer-2" class="drawer-button lg:hidden absolute left-2 top-2 p-4 text-secondary">
          <i class="fa-solid fa-bars fa-2xl"></i>
        </label>

        <!-- CONTENT VIEW dark:bg-[#1e1e1e] -->
        <div class="py-16 lg:py-6 px-6 bg-[#fff]">
          <router-view></router-view>
        </div>
      </div>

      <div class="drawer-side secondary">
        <label for="my-drawer-2" class="drawer-overlay"></label>
        <ul class="menu overflow-y-auto w-80 bg-secondary text-base-content ma-2">
          <li class="pr-4 items-center justify-center min-h-[150px]">
            <img class="h-[100px] object-contain px-6 pb-0 mx-auto"
                 :src="configStore.get('logo.white', require('@/assets/images/venus_logo_white.png'))"
                 alt="Venus GmbH"
            />
          </li>

          <li v-for="(menuItem, index) of menuItems" v-bind:key="index"
              class="rounded-l-md ml-4"
              :class="{'bg-white text-secondary': isCurrent(menuItem.path), 'text-white': !isCurrent(menuItem.path)}"
              @click="currentMenuItem = menuItem">
            <router-link :to="`${menuItem.path}`">
              <div v-if="menuItem.icon">
                <i :class="menuItem.icon"></i>
              </div>

              {{ menuItem.name }}
            </router-link>
          </li>

          <li class="w-full absolute bottom-0 text-white items-center">
            <span>© {{ new Date().getFullYear() }} VENUS GmbH</span>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <success-notification></success-notification>
      <error-notification></error-notification>
    </div>
  </div>
</template>

<script>
import SuccessNotification from "@/components/notification/SuccessNotification";
import ErrorNotification from "@/components/notification/ErrorNotification";
import { mapStores } from "pinia";
import { useAuthStore } from "@/stores/auth";
import Axios from "@auth/vue-share/utility/axios";
import { useConfigStore } from "@/stores/config";

export default {
  components: { ErrorNotification, SuccessNotification },
  computed: {
    ...mapStores(useAuthStore, useConfigStore)
  },
  data() {
    return {
      menuItems: [
        {
          name: "Dashboard",
          icon: "fa-regular fa-table-columns",
          path: "/"
        },
        {
          name: "Benutzer",
          icon: "fa-regular fa-user",
          path: "/users"
        },
        {
          name: "Anwendungen",
          icon: "fa-regular fa-browser",
          path: "/clients"
        },
        {
          name: "Scopes",
          icon: "fa-regular fa-cubes",
          path: "/scopes"
        },
        {
          name: "Claims",
          icon: "fa-regular fa-cube",
          path: "/claims"
        },
        {
          name: "Tokens",
          icon: "fa-regular fa-key",
          path: "/tokens"
        },
        {
          name: "Sessions",
          icon: "fa-regular fa-house-user",
          path: "/sessions"
        },
        {
          name: "Aktivierungsschlüssel",
          icon: "fa-regular fa-key-skeleton",
          path: "/codes"
        }
      ],
      currentMenuItem: undefined,
      loading: false,
      style: {}
    };
  },
  async created() {
    this.loading = true;
    Axios.setToken(this.authStore.getAccessToken);
    await this.configStore.fetchConfig();

    // set style
    this.style = {
      primary: this.configStore.get("colors.light.primary", "#AC965C"),
      secondary: this.configStore.get("colors.light.secondary", "#183857")
    };

    this.loading = false;
  },
  methods: {
    isCurrent(path) {
      return this.$route.path === path || !!this.$route.matched.find((route) => route.path === path);
    }
  }
};
</script>
